import { render, staticRenderFns } from "./devolucionLeecheros.vue?vue&type=template&id=05d8fa80&"
import script from "./devolucionLeecheros.vue?vue&type=script&lang=js&"
export * from "./devolucionLeecheros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports